export const sendModel = (data) => (
    {
        details: {
            personalInformation: {
                affiliatedPensionFund: data?.affiliatedPensionFund === 'true',
                zurichMA: data?.zurichMA,
                destinedLife: data?.destinedLife,
                occupation: +data?.occupation,
                employmentContinuation: data?.employmentContinuation,
            },
        },
    }
);
